import { IonLoading } from '@ionic/react'

import { useAccount } from '../../contexts/authContext'
import { useClientContactInfo } from '../../hooks/clients/queries'
import { useBoolean } from '../../hooks/use-boolean'
import { AccountInfoCard } from '../../clients/components/client-info/account-info-card'
import { ContactCard } from '../../clients/components/client-info/contact-card'
import { PhoneCard } from '../../clients/components/client-info/phone-card'
import { OptInClientCard } from '../../clients/components/client-info/opt-in-client-card'
import { PosUnsubscribedCard } from '../../clients/components/client-info/pos-unsubscribed-card'
import { SubscriptionInfoCard } from '../../clients/components/client-info/subscription-info-card'
import { SubscriptionStatusCard } from '../../clients/components/client-info/subscription-status-card'

function ClientInfoDisplay({ clientId }: { clientId: string }) {
  const clientContactInfoQuery = useClientContactInfo(clientId)
  const account = useAccount()

  const [isEditing, { off: enableEditing, on: disableEditing }] = useBoolean()

  const canOptInClient =
    account.allowUserOptIn &&
    (clientContactInfoQuery.data?.defaultPhoneNumber?.optInState ===
      'NOT_INITIALIZED' ||
      clientContactInfoQuery.data?.defaultPhoneNumber?.optInState ===
        'PENDING') &&
    clientContactInfoQuery.data?.defaultPhoneNumber?.e164 &&
    clientContactInfoQuery.data?.posActive !== false &&
    !Boolean(clientContactInfoQuery.data?.unsubscribedAt)

  if (clientContactInfoQuery.data) {
    const {
      defaultPhoneNumber,
      objectId,
      phoneNumbers,
      posActive,
      unsubscribedAt,
    } = clientContactInfoQuery.data
    const isUnsubscribed = Boolean(unsubscribedAt)

    return (
      <section className="ion-padding space-y-4">
        {/* Contact Info - Phone */}
        <div>
          <h2>Contact Info</h2>
          <div className="space-y-3">
            {/* Phone */}
            <PhoneCard
              clientId={objectId}
              isUnsubscribed={isUnsubscribed}
              phoneNumbers={phoneNumbers}
              isEditDisabled={isEditing}
              updateEditStatus={(status) =>
                status ? enableEditing() : disableEditing()
              }
            />
            {/* Contact Info */}
            <ContactCard
              client={clientContactInfoQuery.data}
              isEditDisabled={isEditing}
              updateEditStatus={(status) =>
                status ? enableEditing() : disableEditing()
              }
            />
          </div>
        </div>

        {/* Group Info */}
        {account.account.settings.nonIntegrated ? (
          <div>
            <h2>Account Info</h2>
            <AccountInfoCard
              clientId={objectId}
              group={clientContactInfoQuery.data.group}
              isEditDisabled={isEditing}
              updateEditStatus={(status) =>
                status ? enableEditing() : disableEditing()
              }
            />
          </div>
        ) : null}

        {/* Subscription Info */}
        <div>
          <h2>Subscription Info</h2>
          <div className="space-y-3">
            <SubscriptionInfoCard
              clientId={objectId}
              isEditDisabled={isEditing}
              unsubscribedAt={unsubscribedAt}
              updateEditStatus={(status) =>
                status ? enableEditing() : disableEditing()
              }
            />
            {/* Subscription Status */}
            <SubscriptionStatusCard phoneNumbers={phoneNumbers} />
            {/* POS Unsubscribed */}
            {posActive === false ? <PosUnsubscribedCard /> : null}
            {/* Opt In Client */}
            {canOptInClient ? (
              <OptInClientCard
                clientId={objectId}
                defaultPhoneNumber={defaultPhoneNumber}
              />
            ) : null}
          </div>
        </div>
      </section>
    )
  }

  return <IonLoading isOpen message="Loading Contact Info..." />
}

export { ClientInfoDisplay }
